module.exports = __webpack_public_path__ + "static/media/delivered.1b79c58f.svg";